import { Navigate } from 'react-router-dom';
import { getArea } from '../utils/subdomain';

/**
 * Garante que uma rota só é servida no subdomínio da sua área
 * (app./cliente./operador./hub./parceiro.speedorder.com.br).
 * Se o subdomínio atual for de outra área, manda pra tela de login
 * em vez de renderizar a página. Em ambientes sem subdomínio mapeado
 * (localhost, preview da Vercel) não restringe nada.
 */
export function AreaGate({ area, children }) {
  const currentArea = getArea();

  if (currentArea && currentArea !== area) {
    return <Navigate to="/home" replace />;
  }

  return children;
}
